<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{mType == '2' ? '行政采购项目' : '人力资源项目'}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="mType == '2' ? '/admin' : '/human'">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}项目</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">项目信息</div>
        <el-form-item label="项目名称：" prop="contract_name">
          <el-col :span="12">
            <el-input placeholder="请输入" maxlength="100" v-model="form.contract_name" clearable
              :disabled="form.status == '5'" />
          </el-col>
        </el-form-item>

        <el-form-item label="项目时间：" prop="project_time">
          <el-col :span="12">
            <el-date-picker v-model="form.project_time" type="datetimerange" range-separator="--"
              value-format="yyyy-MM-dd" start-placeholder="项目开始时间" end-placeholder="项目结束时间" style="width:100%;"
              @change="contractTime" :disabled="form.status == '5'">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="选择项目负责人：" prop="manager_id" v-if="level == 1">
          <el-col :span="12">
            <el-select v-model="form.manager_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="managerChange" :disabled="form.status == '5'">
              <el-option :label="`${v.realname} ${v.en_name}`" :value="v.id" v-for="(v, i) in userList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="">
          <el-col :span="10">
            <el-button @click="resetForm('form')">取消</el-button>
          </el-col>
          <el-col :span="10">
            <el-button type="primary" @click="showConfirm">确定创建</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="创建项目" :visible.sync="confirmShow" width="600px">
      <ul class="aul ulist" style="padding:0; min-height: 100px;">
        <li>
          <span>项目名称：</span>
          <span>{{ form.contract_name }}</span>
        </li>
        <li>
          <span>项目时间：</span>
          <span>{{ form.project_start_time }} - {{ form.project_end_time }}</span>
        </li>
        <li>
          <span>项目负责人：</span>
          <span>{{ form.manager_name }}</span>
        </li>
        <li><span style="margin: 0 auto;">注：确定创建后不能修改项目信息</span></li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmShow = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form', '0')">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from '@/api'
import { timeFormat } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'prodetail',
  data() {
    return {
      nodeLimtList: [],
      isDraft: '',//用来判断当option为2时，从草稿变创建
      level: '',
      realName: '',
      userId: '',
      userList: [],
      mType: '',
      form: {
        id: '',
        //项目信息
        contract_name: '',
        project_time: ['', ''],
        manager_id: '',
        manager_name: '',
        is_draft: '0',
      },
      p: 1,
      rules: {

      },
      confirmShow: false,
    }
  },
  created() {
    this.query = this.$route.query
    this.mType = this.query.mType
    this.query.id && this.getDetail(this.query.id)
    if (!this.query.id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
    }
    setTimeout(() => {
      //权限
      this.level = store.state.level
      this.realName = store.state.realName
      this.userId = store.state.userId
    }, 200);
  },
  mounted() {
    this.getUserList()
  },
  watch: {

  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    showConfirm() {
      if (!this.form.contract_name) {
        this.$message.error('请先添加项目!')
        return false
      }
      if (!this.form.project_time[0] || !this.form.project_time[1]) {
        this.$message.error('请先添加项目时间!')
        return false
      }
      if (this.level != 1) {
        this.form.manager_id = this.userId
        this.form.manager_name = this.realName
      }
      this.confirmShow = true;
    },
    getUserList() {
      this.$fly
        .post('ApiAdministrative_getAdminUserList.html', {
          per_page: 5000,
          mType: this.mType,
        })
        .then((res) => {
          this.userList = res.filter((item) => {return item.realname != '超管'})
        })
    },
    managerChange(v) {
      let manager_name = ''
      this.userList.forEach(item => {
        if (item.id == v) {
          manager_name = item.realname
        }
      })
      this.form.manager_name = manager_name
    },
    //项目时间调整
    contractTime() {
      const time = this.form.project_time || ['', '']
      this.form.project_start_time = this.fdate(time[0])
      this.form.project_end_time = this.fdate(time[1])
    },
    getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const apiUrl = 'ApiAdministrative_projectDetail.html'
      this.$fly
        .post(apiUrl, {
          id: id,
        })
        .then((res) => {
          let form = res.item_info
          delete form.is_apply
          this.isDraft = form.is_draft
          console.log('isDraft',this.isDraft);
          //修改0000-00-00错误显示1899年情况
          form.project_start_time = timeFormat(form.project_start_time)
          form.project_end_time = timeFormat(form.project_end_time)
          //初始project_time
          form.project_time = ['', '']
          form.project_time[0] = form.project_start_time
          form.project_time[1] = form.project_end_time
          this.form = form
          // this.managerChange(form.manager_id)
        })
    },
    submitForm(formName, is_draft = '1') {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateProject(is_draft)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdateProject(is_draft = '1') {
      this.form.id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      const apiUrl = 'ApiAdministrative_createOrUpdateProject'
      const tempForm = JSON.parse(JSON.stringify(this.form))
      const { id, project_start_time, project_end_time, manager_id, manager_name, contract_name, option } = tempForm
      const postData = { id, project_start_time, project_end_time, manager_id, manager_name, contract_name, option }
      if (this.level != 1) {
        postData.manager_id = this.userId
        postData.manager_name = this.realName
      }
      this.$fly
        .post(apiUrl, {
          ...postData,
          mType: this.mType,
          is_draft: is_draft,
          // is_creat: (this.form.option == '2' && this.isDraft != is_draft) ? '1' : '', 
          //isDraft为临时存储接收到的is_draft
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }

  .aul.ulist {
    min-height: 480px;
    padding: 20px 0;
    font: 14px/2 $font;
    text-align: left;

    >li {
      padding: 0 60px;
      display: flex;
      flex-flow: row nowrap;

      span {
        display: inline-block;
        width: 50%;
      }
    }

    .ulform {
      padding: 0 60px;
    }

    .el-form-item--small.el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>
